'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdViewModule = function MdViewModule(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.6 8.4h8.4v10h-8.4v-10z m-10 10v-10h8.4v10h-8.4z m10 11.6v-10h8.4v10h-8.4z m-10 0v-10h8.4v10h-8.4z m-10 0v-10h8.4v10h-8.4z m0-11.6v-10h8.4v10h-8.4z' })
        )
    );
};

exports.default = MdViewModule;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/view-module.js
// module id = 2109
// module chunks = 168707334958949